import { render } from "./loading-icon.vue?vue&type=template&id=aa14bada"
import script from "./loading-icon.vue?vue&type=script&lang=js"
export * from "./loading-icon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__